
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PieChart } from 'lucide-react';

const SectorAllocationManager = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <PieChart className="h-6 w-6" />
          Sector Allocation
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <PieChart className="h-16 w-16 mb-4 text-gray-400" />
          <h3 className="text-lg font-semibold mb-2">Coming Soon</h3>
          <p className="text-gray-500">Sector allocation functionality will be available in a future update.</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default SectorAllocationManager;
